import { render, staticRenderFns } from "./cmpCard.vue?vue&type=template&id=08ab54a0&scoped=true"
import script from "./cmpCard.vue?vue&type=script&lang=js"
export * from "./cmpCard.vue?vue&type=script&lang=js"
import style0 from "./cmpCard.vue?vue&type=style&index=0&id=08ab54a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ab54a0",
  null
  
)

export default component.exports